import React from 'react'

import LetsTalkCta from '../LetsTalkCta'
import { getEnterpriseAIContent } from '../../constants/enterpriseAIContent'

const EnterpriseAIFinalCTA = ({ lang }) => {
  const { finalCta } = getEnterpriseAIContent(lang)
  const isEn = lang === 'en'

  return (
    <section className="enterprise-ai-final-cta" aria-labelledby="enterprise-ai-final-cta-heading">
      <div className="content container">
        <div className="enterprise-ai-final-cta__card">
          <h2 id="enterprise-ai-final-cta-heading" className="enterprise-ai-final-cta__heading">
            {finalCta.heading}
          </h2>
          <p className="enterprise-ai-final-cta__body">{finalCta.body}</p>
          <LetsTalkCta
            isEn={isEn}
            tone="onDark"
            label={finalCta.cta}
            className="enterprise-ai-final-cta__link"
          />
        </div>
      </div>
    </section>
  )
}

export default EnterpriseAIFinalCTA
